import axios from "axios";
import { CONFIG } from "@/constants/config.js";

const distributorBackend = CONFIG.BACKEND_URL + "distributor";

const state = {
  distributor: {},
  distributors: [],
  loading: false,
  error: "",
  currentPage: 1,
  numPages: 1,
  totalRows: 0,
};

const config = () => ({
  headers: {
    Token: localStorage.getItem("accessToken"),
  },
});

const getters = {
  distributor: (state) => state.distributor,
  allDistributors: (state) => state.distributors,
  distributorsLoading: (state) => state.loading,
  distributorsError: (state) => state.error,
  distributorsCurrentPage: (state) => state.currentPage,
  distributorsNumPages: (state) => state.numPages,
  distributorsTotalRows: (state) => state.totalRows,
};

const actions = {
  async getDistributor({ commit /*, dispatch */ }, id) {
    commit("setLoading", true);
    await axios
      .post(`${distributorBackend}/${id}/`, null, config())
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributor", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
        commit("setLoading", false);
      });
  },
  async getDistributors({ commit /*, dispatch */ }, filter = null) {
    commit("setLoading", true);
    await axios
      .post(`${distributorBackend}/all/`, filter, config())
      .then(async (response) => {
        commit("setLoading", false);
        await commit("setDistributors", response.data);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  async addDistributor({ commit /*, dispatch */ }, expense) {
    commit("setLoading", true);
    await axios
      .post(`${distributorBackend}/insert/`, expense, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  async editDistributor({ commit, dispatch }, expense) {
    commit("setLoading", true);
    await axios
      .patch(`${distributorBackend}/update/`, expense, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  async deleteDistributor({ commit, dispatch }, id) {
    commit("setLoading", true);
    await axios
      .delete(`${distributorBackend}/delete/${id}/`, config())
      .then(async () => {
        commit("setLoading", false);
        commit("setError", "");
      })
      .catch(async (error) => {
        if (error.response) {
          await commit("reset");
          commit("setError", error.response.data.message);
        } else {
          // dispatch(
          //   "notification/AddNotification",
          //   { type: "error", message: "There has been an error please try again another time." },
          //   { root: true }
          // );
          console.log(error);
        }
      });
  },
  async resetDistributor({ commit }) {
    await commit("reset");
  },
};

const mutations = {
  reset(state) {
    state.distributor = {};
    state.distributors = [];
    state.loading = false;
    state.error = "";
    state.currentPage = 1;
    state.numPages = 1;
    state.totalRows = 0;
  },
  setDistributor(state, response) {
    state.distributor = response;
  },
  setDistributors(state, response) {
    state.distributors = response.distributors;
    state.currentPage = response.currentPage;
    state.numPages = response.numPages;
    state.totalRows = response.totalRows;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
